<template>
  <div :data-testid="TEST_IDS.ROOT" class="subcategory-pills">
    <a
      :data-testid="TEST_IDS.ALL_PILL"
      :href="basePath"
      class="subcategory-pill"
      :class="{ 'subcategory-pill--active': !selectedSubcategory }"
    >
      {{ translations.allArticles }}
    </a>
    <a
      v-for="subcategory in displayedPills"
      :key="subcategory"
      :data-testid="pillTestId(subcategory)"
      :href="pillHref(subcategory)"
      class="subcategory-pill"
      :class="{ 'subcategory-pill--active': isPillActive(subcategory) }"
    >
      {{ subcategory }}
    </a>
    <button
      v-if="hasOverflow"
      :data-testid="TEST_IDS.VIEW_MORE_BUTTON"
      type="button"
      class="subcategory-pill subcategory-pill--view-more"
      @click="openModal"
    >
      <fluent-icon icon="more-horizontal" size="14" />
      {{ translations.viewMore }}
    </button>
    <subcategories-modal
      v-if="isModalOpen"
      :show="isModalOpen"
      :subcategories="subcategories"
      :selected-subcategory="selectedSubcategory"
      :base-path="basePath"
      :translations="translations"
      :on-close="closeModal"
    />
  </div>
</template>

<script>
import SubcategoriesModal from './SubcategoriesModal.vue';
import subcategoriesBarMixin from './mixins/subcategoriesBarMixin';

export default {
  name: 'SubcategoriesBar',
  components: { SubcategoriesModal },
  mixins: [subcategoriesBarMixin],
};
</script>

<style src="./styles/SubcategoriesBar.scss" lang="scss" scoped></style>
